import React, { useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import FileUploadSVG from 'assets/fileUploadSVG';
import { Divider, List, ListItem, ListItemButton, ListItemText, ToggleButton } from '@mui/material';
import CsvFileUploadSVG from 'assets/csvFileSVG';
import { Clear } from '@mui/icons-material';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function CdadHeaderFileUploadDialog({ fileUploadOpen, fileName, setFileUploadOpen, fileUploadFunc, downloadCSVSample, setFileName, setVinListData, vinListData }: any) {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [alignment, setAlignment] = useState(vinListData?.length > 0 ? 'viewUpload' : 'newUpload');
    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Trigger file input click
        }
    };

    useEffect(() => {
        vinListData?.length > 0 ? setAlignment('viewUpload') : setAlignment('newUpload');
    }, [fileUploadOpen, vinListData])

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={setFileUploadOpen}
                aria-labelledby="customized-dialog-title"
                open={fileUploadOpen}
            >
                <div style={{ padding: "8px", display: "flex", justifyContent: "center" }}>
                    <ToggleButtonGroup
                        value={alignment}
                        exclusive
                        aria-label="text alignment"
                    >
                        <ToggleButton
                            value="newUpload"
                            aria-label="left aligned"
                            onClick={() => setAlignment('newUpload')}
                        >
                            New Upload
                        </ToggleButton>
                        <ToggleButton
                            value="viewUpload"
                            aria-label="right aligned"
                            disabled={vinListData?.length === 0}
                            onClick={() => setAlignment('viewUpload')}
                        >
                            View Upload
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
                {alignment === "newUpload" ? <div id="vinUpload">
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        VIN File Upload
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={setFileUploadOpen}
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <div style={{ padding: "8px" }}>
                            <div id="fileUploadTop">
                                <div style={{
                                    width: "500px", height: "150px", border: "1px dashed #D5D5D5", display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center', flexDirection: "column"
                                }}>
                                    <div>
                                        <input
                                            type="file"
                                            onChange={fileUploadFunc}
                                            accept={".csv"}
                                            ref={fileInputRef}
                                            style={{ display: "none" }}
                                            id="file-upload"
                                            multiple
                                        />
                                        <IconButton
                                            aria-label="close"
                                            onClick={handleButtonClick}
                                            sx={{ color: '#484848' }}
                                        >

                                            <FileUploadSVG />
                                        </IconButton>
                                    </div>
                                    <div>
                                        <Typography>Click or drag file to this area to upload</Typography>

                                    </div>
                                </div>
                                <div style={{ padding: "1rem 0" }}><Typography sx={{ color: "#9D9D9D" }}>Formats accepted are .csv</Typography></div>
                            </div>
                            <Divider />
                            <div id="fileUploadBottom" style={{ paddingTop: "1rem" }}>
                                <div><Typography>If you do not have a file you can use the sample below:</Typography></div>
                                <div style={{ paddingTop: "1rem" }}>
                                    <Button
                                        variant="outlined"
                                        startIcon={<CsvFileUploadSVG />}
                                        sx={{
                                            borderColor: '#CBCBCB', // Change border color
                                            color: '#606260',       // Change text color
                                            '&:hover': {
                                                borderColor: '#CBCBCB', // Change border color on hover
                                                color: '#606260',       // Change text color on hover
                                            },
                                        }}
                                        onClick={() => {
                                            downloadCSVSample();
                                        }}
                                    >
                                        Download Sample Template
                                    </Button>
                                </div>
                                <div>
                                    {fileName?.length > 0 && (
                                        <Typography variant="body2" flex={1}>
                                            {fileName}
                                            <IconButton
                                                color="error"
                                                onClick={() => {
                                                    setFileName("");
                                                    setVinListData([]);
                                                }}
                                                edge="end"
                                            >
                                                <Clear />
                                            </IconButton>
                                        </Typography>
                                    )}
                                </div>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions sx={{ backgroundColor: "#D9D9D9" }}>
                        <Button sx={{
                            backgroundColor: "#FFFFFF",
                            borderColor: '#CBCBCB', // Change border color
                            color: '#606260',       // Change text color
                            '&:hover': {
                                borderColor: '#CBCBCB', // Change border color on hover
                                color: '#606260',       // Change text color on hover
                            },
                        }} variant='outlined' autoFocus onClick={setFileUploadOpen}>
                            Cancel
                        </Button>
                        <Button variant='contained' autoFocus onClick={setFileUploadOpen}>
                            Continue
                        </Button>
                    </DialogActions>
                </div> :
                    <div id="vinUpload">
                        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                            View Uploaded VINS
                        </DialogTitle>
                        <IconButton
                            aria-label="close"
                            onClick={setFileUploadOpen}
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: theme.palette.grey[500],
                            })}
                        >
                            <CloseIcon />
                        </IconButton>
                        <DialogContent dividers>
                            <div style={{ padding: "8px", width: "500px", maxHeight: "400px", overflowY: "auto" }}>
                                <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                    {vinListData?.map((value: string, index: number) => {
                                        const labelId = `checkbox-list-secondary-label-${value}`;
                                        return (
                                            <><ListItem
                                                key={value}
                                                disablePadding
                                            >
                                                <ListItemButton>
                                                    <ListItemText id={labelId} primary={value} />
                                                </ListItemButton>
                                            </ListItem>{vinListData?.length - 1 === index ? null : <Divider />}</>
                                        );
                                    })}
                                </List>
                            </div>
                        </DialogContent>
                        <DialogActions sx={{ backgroundColor: "#D9D9D9" }}>
                            <Button variant='contained' autoFocus onClick={setFileUploadOpen}>
                                Close
                            </Button>
                        </DialogActions>
                    </div>
                }
            </BootstrapDialog>
        </React.Fragment>
    );
}